// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__ENIXy","alert":"SettungsInbox_alert__3vTuW"};